module.exports = __webpack_public_path__ + "static/media/how_fi.d15e78a5.vtt";